import TextareaItem from 'antd-mobile/lib/textarea-item';
export default TextareaItem;



// WEBPACK FOOTER //
// ./components/textarea-item/index.tsx